import {Stack, Typography} from '@mui/material';
import React, {Fragment} from 'react';

import {CustomDivider} from '../styles';
import {defaultVariantProp} from './constants';
import {RowCompoundProps} from './types';

export const Compound = ({
	items,
	hiddenDivider = false,
	primaryColor = 'text.secondary',
	secondaryColor = 'text.primary',
	variants = defaultVariantProp,
}: RowCompoundProps) => (
	<Fragment>
		<Stack direction="row" justifyContent="space-between" width="100%">
			{items.map(item => (
				<Stack flex={1} key={item.title}>
					<Typography variant={variants.title} color={primaryColor}>
						{item.title}
					</Typography>
					<Stack direction="row" alignItems="center" gap={0.5}>
						{item.icon}
						<Typography
							variant={variants.value}
							fontWeight={400}
							color={secondaryColor}>
							{item.value}
						</Typography>
					</Stack>
					{!hiddenDivider ? <CustomDivider /> : null}
				</Stack>
			))}
		</Stack>
	</Fragment>
);
